import catalog from '../../../../../docs/regulatory/opin/catalog/opin-api-catalog.json';
import conformanceEvidence from '../../../../../docs/regulatory/opin/catalog/opin-conformance-evidence.json';
import drift from '../../../../../docs/regulatory/opin/catalog/opin-drift-report.json';
import gapReport from '../../../../../docs/regulatory/opin/catalog/opin-gap-report.json';
import mockOpinCoverage from '../../../../../docs/regulatory/opin/catalog/opin-mockopin-coverage.json';
import type {
  CatalogRow,
  ConformanceEvidenceRow,
  DriftReport,
  FamilyComparison,
  MockOpinFamilyComparison,
} from '../contract/catalog-types.ts';

// SAFETY: generated OPIN catalog JSON is produced by the regulatory catalog pipeline and matches CatalogRow[].
export const opinCatalog = catalog as CatalogRow[];
// SAFETY: generated OPIN conformance evidence JSON matches ConformanceEvidenceRow[].
export const opinConformanceEvidence = conformanceEvidence as ConformanceEvidenceRow[];
// SAFETY: generated OPIN drift report JSON matches DriftReport.
export const opinDrift = drift as DriftReport;
// SAFETY: generated OPIN gap report JSON matches FamilyComparison[].
export const opinGapReport = gapReport as FamilyComparison[];
// SAFETY: generated OPIN MockOPIN coverage JSON matches MockOpinFamilyComparison[].
export const opinMockOpinCoverage = mockOpinCoverage as MockOpinFamilyComparison[];
